module.exports = __webpack_public_path__ + "static/media/loader.a0d531a9.svg";